import { useQuery } from "react-query";
import { sureApiCall } from "src/api/axiosClient/sureApi";
import { zodParseWithDetailedLog } from "src/api/apiErrorLogs";
import { UnitSchema } from "./useUnitSelector";

export const getOneUnitApiKey = "getOneUnit";

export const useGetOneUnit = (identifier: string | number | undefined, options?: { enabled?: boolean }) => {
    const { enabled = true } = options || {};

    const isEnabled = identifier !== undefined && enabled;

    const query = useQuery({
        queryKey: [getOneUnitApiKey, identifier],
        queryFn: async () => {
            if (!identifier) {
                return;
            }

            return await sureApiCall.get(`/api/units/${identifier}`);
        },
        select: (response) => {
            if (!response) {
                return;
            }

            const unit = response.data;
            const data = zodParseWithDetailedLog(unit, UnitSchema, {
                operation: "GET",
                endpoint: "/units/:id",
            });
            return data;
        },
        enabled: isEnabled,
        staleTime: 300000, // Cache for 5 minutes
        cacheTime: 300000, // Keep in cache for 5 minutes
    });

    return {
        unit: query.data,
        ...query,
    };
};
